import axiosFetch from './config';

export const getValidateNumbers = async (data) => {
  const token = localStorage.getItem("token")
  return axiosFetch({
    method: 'POST',
    url: '/directory/verification',
    data,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}

export const getIdenticator = async (phoneNumber) => {
  const token = localStorage.getItem("token")
  return axiosFetch({
    method: 'GET',
    url: `/directory/${phoneNumber}`,
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}

export const getShortcutDirectoy = async () => {
  const token = localStorage.getItem("token")
  return axiosFetch({
    method: 'GET',
    url: '/shortcut?shortcutType=DIRECTORY',
    headers: {
      Authorization: 'Bearer ' + token,
    }
  })
}